import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { RadioModule } from '../radio/radio.component';
import { TranslatePipeModule } from '../translate.pipe';
import { TeacherSwitchModalComponent } from './teacher-switch-modal/teacher-switch-modal.component';
import { TeacherSwitchSelectionBoxComponent } from './teacher-switch-modal/teacher-switch-selection-box/teacher-switch-selection-box.component';
import { TeacherSwitchComponent } from './teacher-switch.component';
import { TeacherSwitchFallbackItemComponent } from './teacher-switch-modal/teacher-switch-fallback-item/teacher-switch-fallback-item.component';

@NgModule({
    imports: [CommonModule, NgbModalModule, TranslatePipeModule, RadioModule],
    declarations: [TeacherSwitchComponent, TeacherSwitchSelectionBoxComponent, TeacherSwitchModalComponent, TeacherSwitchFallbackItemComponent],
    exports: [TeacherSwitchComponent],
    entryComponents: [
        TeacherSwitchModalComponent
    ]
})
export class TeacherSwitchModule { }



// WEBPACK FOOTER //
// ./ts/app/shared/teacher-switch/teacher-switch.module.ts